import { Box, Typography, useTheme } from "@mui/material"
import CustomTable from "../investorOverview/common/customTable"
import { CategoryTableBody, tableHeaderData } from "../investorOverview/mutualFund/common/Table"
import { Order, SortingObj } from "../investorOverview/types"

type CategoriesTableProps = {
    title: string
    tableData: any
    isLoading: boolean
    handleTableSorting: (orderBy: string, order: Order) => void
    sortingObj: SortingObj,
    setSortingObj: ({ order, orderBy }: SortingObj) => void
}


export default function CategoryWiseBreakup(props: CategoriesTableProps): JSX.Element {
    const { title, tableData, isLoading, handleTableSorting, sortingObj } = props;
    const { palette } = useTheme()
    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            border: `3px solid ${palette.stroke.main}`,
            borderRadius: '20px'
        }}>
            <Typography variant="h2" color={palette.text.primary}>
                {title}
            </Typography>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={4}
                    isLoading={isLoading}
                    tableBody={
                        <CategoryTableBody
                            tableBodyData={tableData || []}
                            handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                        />
                    }
                    tableData={tableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={tableHeaderData}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px",
                        }
                    }}
                    handleSort={handleTableSorting}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        },
                    }}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                />
            </Box>
        </Box>
    )
}